import { memo } from 'react'

export const Table = memo(({ className, ...rest }: React.TableHTMLAttributes<HTMLTableElement>) => (
  <table className={className} {...rest} />
))
Table.displayName = 'Table'

export const Thead = memo((props: React.HTMLAttributes<HTMLTableSectionElement>) => (
  <thead {...props} />
))
Thead.displayName = 'Thead'

export const Tbody = memo((props: React.HTMLAttributes<HTMLTableSectionElement>) => (
  <tbody {...props} />
))
Tbody.displayName = 'Tbody'

export const Tr = memo((props: React.HTMLAttributes<HTMLTableRowElement>) => <tr {...props} />)
Tr.displayName = 'Tr'

export const Th = memo((props: React.ThHTMLAttributes<HTMLTableCellElement>) => <th {...props} />)
Th.displayName = 'Th'

export const Td = memo((props: React.TdHTMLAttributes<HTMLTableCellElement>) => <td {...props} />)
Td.displayName = 'Td'
